export default __webpack_public_path__ + "static/media/MON.2b4b09d9.svg";